import { SvgProps } from "../../types";

const Search = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.65}
    height={14.65}
    fill="none"
    {...props}>
    <path
      fill="#4C5269"
      d="M6.22 11.01c-1.514 0-2.795-.524-3.843-1.573C1.328 8.39.804 7.107.804 5.594c0-1.514.524-2.795 1.573-3.844C3.425.701 4.707.177 6.22.177c1.514 0 2.796.524 3.844 1.573 1.049 1.049 1.573 2.33 1.573 3.844a5.08 5.08 0 0 1-1.083 3.166l4.666 4.667a.79.79 0 0 1 .23.583.79.79 0 0 1-.23.584.79.79 0 0 1-.583.229.79.79 0 0 1-.583-.23L9.387 9.928A5.078 5.078 0 0 1 6.22 11.01Zm0-1.666c1.042 0 1.927-.365 2.657-1.094.729-.73 1.093-1.615 1.093-2.656 0-1.042-.364-1.927-1.093-2.657-.73-.729-1.615-1.093-2.657-1.093-1.041 0-1.927.364-2.656 1.093-.729.73-1.094 1.615-1.094 2.657 0 1.041.365 1.927 1.094 2.656.73.73 1.615 1.094 2.656 1.094Z"
    />
  </svg>
);
export default Search;
